<template>
  <div class="user-avator-dropdown">
    <Dropdown @on-click="handleClick">
      <Badge>
        <!--<Avatar :src="userAvator"/>-->
      </Badge>
      <span class="ml8">{{userName}}</span>
      <!--<Icon :size="18" type="md-arrow-dropdown"></Icon>-->
      <DropdownMenu slot="list">
        <DropdownItem name="logout">退出登录</DropdownItem>
      </DropdownMenu>
    </Dropdown>
  </div>
</template>

<script>
import { getCookie } from '../../../../libs/util'
import './user.less'
import { mapActions } from 'vuex'
export default {
  name: 'User',
  props: {
    userAvator: {
      type: String,
      default: ''
    },
    messageUnreadCount: {
      type: Number,
      default: 0
    },
    userName: {
      default: ''
    }
  },
  // computed: {
  //   ...mapState({
  //     userName: state => getCookie('login_name')
  //   })
  // },
  methods: {
    ...mapActions([
      'handleLogOut'
    ]),
    logout (param) {
      let getId = getCookie('userId')
      this.$api.logout({ user_id: getId }).then(res => {
        this.$router.push({
          name: 'login'
        })
        this.$store.dispatch('handleLogOut')
      })
    },
    message () {
      // this.$router.push({
      //   name: 'message_page'
      // })
    },
    handleClick (name) {
      switch (name) {
        case 'logout': this.logout()
          break
        case 'message': this.message()
          break
      }
    }
  }
}
</script>
